<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/transplus_warehouse.jpg')"
      />
      <div class="content-center">
        <div class="container">
          <h1
            class="title"
            v-html="$t('General.WarehouseDistribution')"
          >
            Warehousing and Distribution<span class="tpgreen">.</span class="tpgreen"></span>
          </h1>
        </div>
      </div>
    </div>
    <!-- -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Warehouse.warehousedesc1')"
            >
              <span class="tpgreen">Precision </span> and <span class="tpgreen">timing </span> are everything when it comes to storage<span class="tpgreen">.</span>
            </h2>
            <h5
              class="description"
              v-html="$t('Warehouse.warehousedesc2')"
            >
              Our strategically located facilities in Eastern Canada provide access to all major highways, international airports, local water ports, and railways.
            </h5>
          </div>
        </div>
      </div>
    </div> 
    
    <!--
    <hr class="tpgreen">

    <div class="section" id="animNumbers">
      <div class="container col-md-8 text-center">
        <div class="row">        
          <div class="container col-md-4" style="border-left:1px solid whitesmoke ;border-right: 1px solid whitesmoke;"> 
            <p>Montreal <br> 2400 Halpern</p>
            <h3> <span class="tpdblue">{{ doors_halp }} <span v-html="$t('Warehouse.doors')">doors</span> </span> <br> <span class="tpgreen">{{ sqft_halp.toLocaleString() }} sq/ft</span></h3>
          </div>
          <div class="container col-md-4" style="border-left:1px solid whitesmoke ;border-right: 1px solid whitesmoke;"> 
            <p>Montreal <br> 6000 Trans Canada</p> 
            <h3> <span class="tpdblue">{{ doors_trans }} <span v-html="$t('Warehouse.doors')">doors</span> </span>  <br> <span class="tpgreen">{{ sqft_trans.toLocaleString() }} sq/ft </span> </h3>            
          </div>
          <div class="container col-md-4" style="border-left:1px solid whitesmoke ;border-right: 1px solid whitesmoke;"> 
            <p>Toronto <br> 7385 Bren Road </p>
            <h3> <span class="tpdblue">{{ doors_bren }} <span v-html="$t('Warehouse.doors')">doors</span> </span>  <br> <span class="tpgreen">{{ sqft_bren.toLocaleString() }} sq/ft </span> </h3>            
          </div>
        </div>
      </div>
    </div>
    -->
    
    <hr class="tpgreen">
      
    <div class="section">
      <div class="container col-md-10">
        <h2
          class="text-center tpdblue"
          v-html="$t('Warehouse.warehousedesc3')"
        >
          Over half a <span class="tpgreen">million square feet</span> <br>
          of warehousing and distribution space <br>
          in between <span class="tpgreen">Montreal</span> & <span class="tpgreen">Toronto.</span> <br>
        </h2>
      </div>
    </div>
    
    <hr class="tpgreen">


    <div class="section">
      <div class="container col-md-10">
        <div class="row">
          <div class="col-md-3  ml-auto mr-auto gap">          
            <div style="color:dodgerblue">
              <i class="far fa-scanner-keyboard fa-6x" />
            </div>
            <h4
              class="card-title "
              v-html="$t('Warehouse.WMS')"
            >
              WMS - Warehouse Management System
            </h4>
            <p
              class="card-text "
              style="font-size:14px"
              v-html="$t('Warehouse.WMSdesc')"
            >
              Our cutting-edge WMS ensures complete control over your inventory. Real-time information is provided through web portals and Electronic Data Interchange (EDI). Upon request, we will work with you to integrate and map your transactions into or from our WMS. Both our WMS and TMS are interactively linked for greater efficiency. 
            </p>
          </div>
          <div class="col-md-3  ml-auto mr-auto gap">
            <div style="color:dodgerblue">
              <i class="far fa-file-certificate fa-6x" />
            </div>
            <h4
              class="card-title"
              v-html="$t('Warehouse.AIB')"
            >
              AIB and HACCP Certified
            </h4>
            <p
              class="card-text"
              style="font-size:14px"
              v-html="$t('Warehouse.AIBdesc')"
            >
              Our facilities are AIB and HACCP certified. These globally recognized standards are key requirements that we meet to ensure your products stay safe throughout storage and distribution. From food to consumer products, we are committed to preventing damage and reducing waste.
            </p>              
              
            <p>
              <img
                slot="image"
                :src="imgAIB"
                width="50%"
              >
              <img
                slot="image"
                :src="imgHACCP"
                width="30%"
              >
            </p>
          </div>

          <div class="col-md-3 ml-auto mr-auto gap">          
            <div style="color:dodgerblue">
              <i class="far fa-shield-check fa-6x" />
            </div>
            <h4
              class="card-title"
              v-html="$t('Warehouse.Customs')"
            >
              Customs Bonded Warehouses Approved
            </h4>
            <p
              class="card-text"
              style="font-size:14px"
              v-html="$t('Warehouse.Customsdesc')"
            >
              We offer bonded warehouses, should you require this service for storing your import or export goods.
            </p>
            <p>
              <img
                slot="image"
                :src="imgCBSA"
                style="display: block; width: 40%;"
              >
            </p>        
          </div>
          <div class="col-md-3 ml-auto mr-auto gap">          
            <div style="color:dodgerblue">
              <i class="far fa-tasks fa-6x" />
            </div>
            <h4
              class="card-title"
              v-html="$t('Warehouse.YMS')"
            >
              YMS - Yard Management System
            </h4>
            <p
              class="card-text"
              style="font-size:14px"
              v-html="$t('Warehouse.YMSdesc')"
            >
              Having the right balance of inbound and outbound freight relies on effective yard management. Real-time yard counts and asset activities enable accurate visibility. For seamless management operations, our YMS is integrated with our WMS and TMS.
            </p>
          </div>
        </div>
      </div>
    </div>  

    <hr class="tpgreen">
    
    <div
      class="section"
      style="border: 0px solid green;"
    >
      <h2 class="title text-center">
        01<span class="tpgreen">.</span><br>
        <span style="font-size: .75em;" v-html="$t('Warehouse.Inventory')">
          Inventory Handling and Consolidation<span class="tpgreen">.</span>
        </span>
      </h2>

      <div class="container elgrey">                
        <div class="row">
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Quantity')"
            >Inventory Quantity Management</span>
            <span
              class="right light"
              v-html="$t('Warehouse.Quantitydesc')"
            >Minimum and maximum SKU replenishment are provided to better manage quantity levels. Lots can also be placed on quality hold, in quarantine, or held pending, if needed.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Lot')"
            >Lot Management</span>
            <span
              class="right light"
              v-html="$t('Warehouse.Lotdesc')"
            >Gain full control over your stock rotation and alert reporting through license plate numbers (LP), dates, or items. We accommodate first in first out (FIFO), last in first out (LIFO), and first expired first out (FEFO) inventory methods.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Pickandpack')"
            >Pick and Pack</span>
            <span
              class="right light"
              v-html="$t('Warehouse.Pickdesc')"
            >Our customer-centred approach ensures that each item is carefully handled, packaged, and labelled. Through piece picking, batch picking, or wave picking, all your inventory is scanned for first in first out (FIFO) purposes.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold;"
              v-html="$t('Warehouse.FullPalPick')"
            >Full Pallet Pick</span>
            <span
              class="right light"
              v-html="$t('Warehouse.FullPaldesc')"
            >Resort to simpler pallet handling intended for your large amount of inventory. We service to both commercial and industrial industries.</span>
          </div>
        </div>
      </div>
    </div>
    

    <hr class="tpgreen">

    
    <div
      class="section"
      style="border: 0px solid green;"
    >
      <h2 class="title text-center">
        02<span class="tpgreen">.</span><br>
        <span style="font-size: 0.75em;" v-html="$t('Warehouse.Customization')">
          Customization and Light Assembly<b class="tpgreen">.</b>
        </span>
      </h2>

      <div class="container elgrey">                
        <div class="row">
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold;"
              v-html="$t('Warehouse.Kitting')"
            >Kitting</span>
            <span
              class="right light"
              v-html="$t('Warehouse.kitdesc')"
            >Our trained and skilled staff meticulously separates, groups, and packages your inventory to build your desired kits. Whether you require labelling, repackaging, or light assembly, receive your items in bulk instead of individually with our cost-effective kitting service.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Rework')"
            >Rework and Repair</span>
            <span
              class="right light"
              v-html="$t('Warehouse.Reworkdesc')"
            >We efficiently build, package, or reconfigure your display pallets and label or re-label your products accordingly. Quality control checks are also administered to meet your standards prior to dispatch. Additionally, we offer pallet strapping or resealing upon request.</span>
          </div>                 

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Securing')"
            >Securing</span>
            <span
              class="right light"
              v-html="$t('Warehouse.SecuringDesc')"
            >We provide a complete range of shrink wrapping, box filling, and product strapping services.</span>
          </div>
        </div>
      </div>
    </div>

    <hr class="tpgreen">


    <div
      class="section"
      style="border: 0px solid green;"
    >
      <h2 class="title text-center">
        03<span class="tpgreen">.</span><br>
        <span style="font-size: .75em;" v-html="$t('Warehouse.Added')">
          Added Value Services<span class="tpgreen">.</span>
        </span>
      </h2>


      <div class="container elgrey">                
        <div class="row">
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.FullSuite')"
            >Full Suite of Container Services</span>
            <span
              class="right light"
              v-html="$t('Warehouse.FullSuitedesc')"
            >Ship and receive at an international level worry-free. Our coordination skills and great attention to detail will ensure seamless distribution through our bonded facilities.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Deconsolidation')"
            >Deconsolidation</span>
            <span
              class="right light"
              v-html="$t('Warehouse.Deconsolidationdesc')"
            >Both timely shipping and long-term storage services are available to your business. We carefully de-stuff your container, properly label your stock, and strategically load it onto pallets.</span>              
          </div>   

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Consolidation')"
            >Consolidation</span>
            <span
              class="right light"
              v-html="$t('Warehouse.Consolidationdesc')"
            >By taking into account the temperature sensitivity or delicate nature of your cargo, we take all necessary measures to block, brace, and secure it accordingly. If needed, we can even load your shipments using heat treated pallets. We aim to eliminate any potential movement during transportation to prevent damage and to secure your cargo.</span>              
          </div> 

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Warehouse.Crossdocking')"
            >Crossdocking and Transloading</span>
            <span
              class="right light"
              v-html="$t('Warehouse.Crossdockingdesc')"
            >Our services ensure your products are transported quickly (within 24 hours). Minimal handling and storage time from the same stock location is cost effective. From machinery to pallets, we handle all types of cargo.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- -->
    <!--<div class="section gotoservices" >-->
    <div class="col-md-8 ml-auto mr-auto text-center">
      <!-- <a href=" https://ca.indeed.com/cmp/Transplus-6" v-html="$t('General.getquotebusiness')">Get a quote for your business  <span class="tpgreen">→</span></a> --> 
      <a
        class="nav-link requestaquote"
        href="/quote"
        style="color:white; text-transform: capitalize;"
      >{{ $t("navbar.quote") }}</a>
    </div>
  </div>
</template>
<script>
import {Collapse, CollapseItem} from '@/components';
import { Card } from '@/components';

export default {
  components: {
    Card,
    Collapse,
    CollapseItem
  },  
  data() {
    return {
      imgWare: "img/transplus_warehouse.jpg",
      imgTrans: "img/bg4.jpg",
      imgFreight: "img/bg3.jpg",
      imgAIB: "img/aib.jpg",
      imgHACCP: "img/haccp.png",      
      imgCBSA: "img/cbsa.jpg",      
      
      doors_halp: 0,
      doors_trans: 0,
      doors_bren: 0,
      doors_halp_tot: 42,
      doors_trans_tot: 21,
      doors_bren_tot: 16,

      sqft_halp: 0,
      sqft_trans: 0,
      sqft_bren: 0,
      sqft_halp_tot: 200000,
      sqft_trans_tot: 120000,
      sqft_bren_tot: 85000,      
    };
  },
  mounted () {
    //window.document.body.onscroll = function() { alert(123); }
    var vm = this
    var observer = new IntersectionObserver(function(entries) {
      // isIntersecting is true when element and viewport are overlapping
      // isIntersecting is false when element and viewport don't overlap
      if(entries[0].isIntersecting === true)
        //alert('Element has just become visible in screen');             
        vm.doors_halp= vm.doors_trans = vm.doors_bren = 0;
        vm.sqft_halp= vm.sqft_trans = vm.sqft_bren = 0;
        vm.animateValue(100);
    }, { threshold: [0] });

    observer.observe(document.querySelector("#animNumbers")); 
  },
  methods: {
    animateValue : function (stepTime) {
      var vm = this
      setInterval(function() {
        if (vm.doors_halp < vm.doors_halp_tot) { vm.doors_halp +=1; }
        if (vm.doors_trans < vm.doors_trans_tot) { vm.doors_trans +=1; }
        if (vm.doors_bren < vm.doors_bren_tot) { vm.doors_bren +=1; }

        if (vm.sqft_halp < vm.sqft_halp_tot) { vm.sqft_halp += 10000; }
        if (vm.sqft_trans < vm.sqft_trans_tot) { vm.sqft_trans +=5000; }
        if (vm.sqft_bren < vm.sqft_bren_tot) { vm.sqft_bren +=5000; }        
      }, stepTime);
    }
  }
};
</script>
<style scoped>

.gap {
  margin:20px
}

@media only screen and (max-width: 600px) { 
  .page-header-small{
            min-height: 40vh;
            max-height: 440px;
    }
  .title{
    font-size:2.75em;
  }
}
</style>
